/**
 * A title turned into an identifier: lowercase, words joined by hyphens, nothing else.
 *
 * For anything a person names and a URL then has to carry — the identifier becomes a path
 * segment, so it is kept to what survives unescaped. Accents are folded rather than dropped, so
 * "Sitios Españoles" reads as "sitios-espanoles" and not "sitios-espaoles".
 */
export const toIdentifier = (title: string): string =>
    title
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
